var swiper = new Swiper(".review-slider", {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    1300: {
      slidesPerView: 4, // You can change this value as needed
      spaceBetween: 20, // You can change this value as needed
    },
    990: {
      slidesPerView: 3, // You can change this value as needed
      spaceBetween: 20, // You can change this value as needed
    },
    750: {
      slidesPerView: 2, // You can change this value as needed
      spaceBetween: 10, // You can change this value as needed
    },
    0: {
      slidesPerView: 1.2, // You can change this value as needed
      spaceBetween: 10, // You can change this value as needed
    }
  }
});
